import React from "react";
import { Box, FormControl, FormHelperText, FormLabel, Switch } from "@mui/joy";

interface PublicSignupToggleProps {
  checked: boolean;
  disabled?: boolean;
  onChange: (checked: boolean) => void;
}

const PublicSignupToggle: React.FC<PublicSignupToggleProps> = ({
  checked,
  disabled = false,
  onChange,
}) => (
  <FormControl
    orientation="horizontal"
    sx={{ justifyContent: "space-between" }}
  >
    <Box>
      <FormLabel>Allow members of this organisation to join</FormLabel>
      <FormHelperText>
        Members of this organisation can find and join this workspace from the
        dashboard. Changes save immediately.
      </FormHelperText>
    </Box>
    <Switch
      checked={checked}
      disabled={disabled}
      onChange={(event) => onChange(event.target.checked)}
      slotProps={{
        input: { "aria-label": "Allow members of this organisation to join" },
      }}
    />
  </FormControl>
);

export default PublicSignupToggle;
